import client from "../libs/HttpClient";

class TheMaticDemoServices {
  static theMaticDemoList(request) {
    const page_no = request.queryKey[1];
    return client.get(`/thematicdemo?page=${page_no}`, request);
  }
  static addTheMaticDemo(request) {
    return client.post(`/add-thematicdemo`, request, {
      headers: {
        "Content-type": "multipart/form-data",
      },
    });
  }
  static updateTheMaticDemo(request) {
    return client.post(`/edit-thematicdemo`, request, {
      headers: {
        "Content-type": "multipart/form-data",
      },
    });
  }
  static viewTheMaticDemo(params) {
    return client.get(`/get-thematicdemo`, { params });
  }
  static deleteTheMaticDemo(params) {
    return client.delete(`/delete-thematicdemo`, { params });
  }
}

export { TheMaticDemoServices };
